module.exports = __webpack_public_path__ + "img/progress_038.fee479cc.png";